<div class="row">
  <div class="col-md-12">
    <div *ngIf="pageSettings.sizeGuide.sizes">



      <p-dataTable class="sm-padding-top"
                   #dt
                   [value]="pageSettings.sizeGuide.sizes"
                   [editable]="true"
                   (onEditComplete)="saveUnitSize($event)"
                   [(selection)]="selectedUnitSize"
                   [responsive]="true">

        <p-header>Unit Sizes</p-header>
        <p-column field="shortName"
                  header="Short Name"
                  [editable]="true"></p-column>
        <p-column field="name"
                  header="Name"
                  [editable]="true"></p-column>
        <p-column field="squareFeet"
                  header="Sq Feet"
                  [editable]="true"></p-column>
        <p-column field="equivalent"
                  header="Equivalent"
                  [editable]="true"></p-column>
        <p-column field="description"
                  header="Description"
                  [editable]="true">
          <ng-template let-col
                       let-car="rowData"
                       pTemplate="body">
            {{car[col.field]}}
          </ng-template>
          <ng-template let-col
                       let-car="rowData"
                       pTemplate="editor">
            <input pInputTextArea
                   id="descriptionss"
                   (change)="saveUnitSize({data: car})"
                   [(ngModel)]="car[col.field]" />
          </ng-template>
        </p-column>
        <p-column field="cc"
                  header="CC"
                  [editable]="true">
          <ng-template let-col
                       let-car="rowData"
                       pTemplate="body">
            {{car[col.field]}}
          </ng-template>
          <ng-template let-col
                       let-car="rowData"
                       pTemplate="editor">
            <md-slide-toggle pInputText
                             id="ccc"
                             (checked)="saveUnitSize({data: car[col.field]})"
                             [(ngModel)]="car[col.field]"></md-slide-toggle>
          </ng-template>
        </p-column>
        <p-column field="img"
                  header="Image"
                  [editable]="true">
          <ng-template let-col
                       let-car="rowData"
                       pTemplate="body">
            <span>
              <img class="facility-logo"
                   src="{{car[col.field]}}"
                   alt="">
            </span>
          </ng-template>
          <ng-template let-col
                       let-car="rowData"
                       pTemplate="editor">
            <input pInputText
                   id="iconUrl"
                   (change)="saveUnitSize({data: car})"
                   [(ngModel)]="car[col.field]" />
          </ng-template>
        </p-column>
        <p-column field="imageAltText"
                  header="Image Alt Text"
                  [editable]="true"></p-column>
        <p-column styleClass="col-button">
          <ng-template let-car="rowData"
                       pTemplate="body">
            <button type="button"
                    class="delete-pug"
                    (click)="delete(car)"
                    pButton
                    icon="fa-trash"></button>

          </ng-template>
        </p-column>

        <p-footer>
          <div class="ui-helper-clearfix"
               style="width:100%">
            <button type="button"
                    class="btn btn-primary"
                    color="primary"
                    style="float:left"
                    (click)="showUnitSizeDialogToAdd()">
              <i class="fa fa-plus"
                 aria-hidden="true"></i> Add
            </button>
          </div>
        </p-footer>
      </p-dataTable>
    </div>
  </div>
</div>

<p-dialog header="Unit Size Details"
          [(visible)]="displayUnitSizeDialog"
          [responsive]="true"
          showEffect="fade"
          [modal]="true"
          [positionTop]="100"
          [width]="500"
          [dismissableMask]="true">
  <div class="ui-grid ui-grid-responsive ui-fluid"
       *ngIf="unitSize">
    <div class="ui-grid-row sm-padding-top">
      <div class="ui-grid-col-4">
        <label for="basedOn">Pick one to copy</label>
      </div>
      <!-- <div class="ui-grid-col-8">
        <p-dropdown [options]="unitSizes" (onChange)="setFromBasedOn()" [autoDisplayFirst]="false" [(ngModel)]="basedOn"></p-dropdown>
      </div> -->
    </div>

    <div class="ui-grid-row sm-padding-top">
      <div class="ui-grid-col-4">
        <label for="shortName">Short name</label>
      </div>
      <div class="ui-grid-col-8">
        <input pInputText
               id="shortName"
               [(ngModel)]="unitSize.shortName" />
      </div>
    </div>
    <div class="ui-grid-row sm-padding-top">
      <div class="ui-grid-col-4">
        <label for="name">Name</label>
      </div>
      <div class="ui-grid-col-8">
        <input pInputText
               id="name"
               [(ngModel)]="unitSize.name" />
      </div>
    </div>
    <div class="ui-grid-row sm-padding-top">
      <div class="ui-grid-col-4">
        <label for="squareFeet">Square Ft</label>
      </div>
      <div class="ui-grid-col-8">
        <input pInputText
               id="squareFeet"
               [(ngModel)]="unitSize.squareFeet" />
      </div>
    </div>

    <div class="ui-grid-row sm-padding-top">
      <div class="ui-grid-col-4">
        <label for="description">Description</label>
      </div>
      <div class="ui-grid-col-8">
        <textarea pInputTextarea
                  id="description"
                  [(ngModel)]="unitSize.description"></textarea>
      </div>
    </div>
    <div class="ui-grid-row sm-padding-top">
      <div class="ui-grid-col-4">
        <label for="img">Img Path/URL</label>
      </div>
      <div class="ui-grid-col-8">
        <input pInputText
               id="img"
               [(ngModel)]="unitSize.img" />
      </div>
    </div>
    <div class="ui-grid-row sm-padding-top">
      <div class="ui-grid-col-4">
        <label for="equivalent">Equivalent To</label>
      </div>
      <div class="ui-grid-col-8">
        <input pInputText
               id="equivalent"
               [(ngModel)]="unitSize.equivalent" />
      </div>
    </div>
    <div class="ui-grid-row sm-padding-top">
      <div class="ui-grid-col-4">
        <p>Is Climate Controlled</p>
      </div>
      <div class="ui-grid-col-8">
        <md-slide-toggle pInputText
                         id="cc"
                         [(ngModel)]="unitSize.cc"></md-slide-toggle>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <button class="btn btn-secondary"
              *ngIf="!newUnitSize"
              style="float:left"
              (click)="deleteUnitSize()">
        <i class="fa fa-close"
           aria-hidden="true"></i> Delete</button>
      <button class="btn btn-primary"
              color="primary"
              (click)="saveUnitSize()">
        <i class="fa fa-check"
           aria-hidden="true"></i> Save</button>
    </div>
  </p-footer>
</p-dialog>



// WEBPACK FOOTER //
// ./src/ng2/app/components/new-size-guide-sizes/new-size-guide-sizes.component.html